// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3UEJ6","info":"PatientInfo_info__1RzXd"};